import { render } from "./DatasetConsultRequested.vue?vue&type=template&id=793f7070"
import script from "./DatasetConsultRequested.vue?vue&type=script&lang=js"
export * from "./DatasetConsultRequested.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__